module.exports = __webpack_public_path__ + "static/img/intro-bg-eng.bca1bdc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/intro-bg-eng.png
// module id = xSxi
// module chunks = 0